import { Box, Divider, Typography } from "../../../../../../components";

export function ProdutoAI({ produtoAI }) {
  return (
    <Box>
      <Divider sx={{ my: 2, border: "1px solid grey" }} />
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
        <div>
          <Typography variant="h6">Análise concluída!</Typography>
          <Typography variant="body2" color="textSecondary">
            Aqui estão as sugestões geradas pelo Assistente Fiscal IA
          </Typography>
        </div>
      </Box>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          gap: 2,
          mb: 2,
        }}
      >
        <Box
          sx={{
            borderRadius: 1,
            border: "1px solid #e6e9ef",
            p: 2,
            background: "#fff",
          }}
        >
          <Typography variant="caption" color="textSecondary">
            NCM
          </Typography>
          <Typography variant="body1" sx={{ mt: 1 }}>
            {produtoAI?.ncm || "-"}
          </Typography>
        </Box>

        <Box
          sx={{
            borderRadius: 1,
            border: "1px solid #e6e9ef",
            p: 2,
            background: "#fff",
          }}
        >
          <Typography variant="caption" color="textSecondary">
            CEST
          </Typography>
          <Typography variant="body1" sx={{ mt: 1 }}>
            {produtoAI?.cest || "-"}
          </Typography>
        </Box>
        <Box
          sx={{
            gridColumn: "1 / -1",
            borderRadius: 1,
            border: "1px solid #e6e9ef",
            p: 2,
            background: "#fff",
          }}
        >
          <Typography variant="caption" color="textSecondary">
            CSO - {produtoAI?.cso || ""}
          </Typography>
          <Typography variant="body1" sx={{ mt: 1 }}>
            {produtoAI?.grupoTributacao || "-"}
          </Typography>
        </Box>

        <Box
          sx={{
            gridColumn: "1 / -1",
            borderRadius: 1,
            border: "1px solid #e6e9ef",
            p: 2,
            background: "#fff",
          }}
        >
          <Typography variant="caption" color="textSecondary">
            Justificativa NCM
          </Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            {produtoAI?.justificativa || "-"}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
